import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import './index.css';

const Header = () => {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/logout', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                // Clear user data
                localStorage.removeItem('isAuthenticated');
                localStorage.removeItem('email');
                localStorage.removeItem('role');
                localStorage.removeItem('userId');

                navigate('/login');
            } else {
                console.error('Logout failed', await response.text());
            }
        } catch (error) {
            console.error('Error during logout request:', error);
        }
    };

    return (
        <Container fluid className="bg-light">
            <Row className="py-3 d-flex align-items-center mb-3 shadow">
                <Col xs={6}>
                    <div className="input-group rounded-pill">
                        {/* Input group content can go here if needed */}
                    </div>
                </Col>
                <Col xs={6} className="d-flex justify-content-end align-items-center gap-3">
                    <div className="rounded-circle overflow-hidden" style={{ width: "35px", height: "35px" }}>
                        <Link to="https://aksharaconnect.aksharafinalytics.in/">
                            <Image
                                src="https://aksharafinalytics.com/wp-content/uploads/2023/07/fav.png"
                                alt="Profile"
                                fluid
                                className="profile"
                                style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                            />
                        </Link>
                    </div>

                    <Button variant="link" className="ml-2 logout-icon" onClick={handleLogout}>
                        <FontAwesomeIcon icon={faSignOutAlt} style={{ cursor: 'pointer' }} />
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

export default Header;
